import styled from 'styled-components';
import ReactSelect from 'react-select';
export const Select = styled(ReactSelect)``;
